<script>
export default {
  name: 'DualList',
  props: ['leftList', 'rightList', 'pushRight', 'pushLeft', 'allLeft', 'allRight'],
  data () {
    return {
      selectedLeftIndex: null,
      selectedRightIndex: null
    }
  },
  methods: {
    pushAllRight() {
      _.each(this.leftList, item => this.rightList.push(item))
      this.$emit('update:leftList', [])
      this.$emit('update:rightList', this.rightList)
    },
    pushAllLeft() {
      _.each(this.rightList, item => this.leftList.push(item))
      this.$emit('update:rightList', [])
      this.$emit('update:leftList', this.leftList)
    },
    setLeftIndex(index) {
      this.selectedLeftIndex = index
    },
    setRightIndex(index) {
      this.selectedRightIndex = index
    },
    pushRight() {
      this.$emit('update:rightList', this.rightList.push(leftList.splice(this.selectedLeftIndex)))
      this.$emit('update:leftList', this.leftList.splice(this.selectedLeftIndex,))
    },
    pushLeft() {
      this.rightList.push(this.leftList.splice(this.selectedLeftIndex, 1))
    }
  }
}
</script>

<template>
  <div id="dualList" class="row full-height">
    <q-list 
      id="leftList" 
      class="col-5"
      >
      <q-item 
        v-for="(leftItem, index) in leftList" 
        :key="index"
        :class="{active: selectedLeftIndex === index}"
        @click.native="setLeftIndex(index)"
        > 
        <q-item-main :label="leftItem" />
      </q-item>
    </q-list>
    <div class="col-2 column justify-center">
      <q-btn class="q-mx-md" label="All Right" @click="pushAllRight()">
      </q-btn>
      <q-btn class="q-mx-md" label="Right" @click="pushRight()">
      </q-btn>
      <q-btn class="q-mx-md" label="Left" @click="pushLeft()">
      </q-btn>
      <q-btn class="q-mx-md" label="All Left" @click="pushAllLeft()">
      </q-btn>
    </div>
    <q-list id="rightList" class="col-5">
      <q-item 
        highlight
        v-for="(rightItem, index) in rightList" 
        :key="index"
        :class="{active: selectedRightIndex === index}"
        @click.native="setRightIndex(index)"
      > 
        <q-item-main :label="rightItem" />
      </q-item>
    </q-list>
  </div>
</template>


<style scoped lang="stylus">

</style>
